import { styled } from 'styled-components';

const ButtonWrapper = styled.div`
  width: 100%;
  flex-shrink: 0;

  & > button {
    height: 40px;
  }

  @media (max-width: 768px) {
    & > button {
      height: 48px;
    }
  }
`;

export { ButtonWrapper };
